import React, { useEffect, useState } from 'react';
import { Avatar, Box, Button, Grid, Typography } from '@mui/material';
import CustomModal from '../../CustomModal/CustomModal';
import ModalFooter from '../../CustomModal/ModalFooter';
import CustomTextField from '../../../components/CustomTextField/CustomTextField';
import CompDirection from '../../../themes/CompDirection';
import CustomRadioButton from '../../../components/CustomRadioButton/CustomRadioButton';
import CustomCheckbox from '../../../components/CustomCheckbox/CustomCheckbox';
import { fonts } from '../../../themes/themes';
import DetailBox from '../../../components/DetailBox/DetailBox';
import { useAppDispatch, useAppSelector } from '../../../../infra/hooks';
import moment from 'moment';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import {
  setAnswerId,
  setApiTrigger,
  setEvaluationId,
  setEvaluatorData,
  setEvaluatorId,
  setEvaluatorSheetData,
  setEvaluatorSheetId,
  setEvaluatorUserId,
  setKpiId,
  setQuestionnaireId,
  setTempEvaluatorSheetData,
  setTriggerData,
} from '../../../../infra/aggregates/myProfile/EvaluatorData/evaluatorData';
import { baseDateFormatting, PENDING, SHORT_ANSWER } from '../../../helper';
import {
  Answer,
  Question,
  Score,
  TeamReviewQuestionnaireModelProps,
} from '../../../../dto/questionnaire.dto';

import toast from 'react-hot-toast';
import { styles } from './style/questionnaire.style';

import {
  mapAnswer,
  questionnaireSubmit,
} from '../../../../services/questionnaire.service';
import { useTranslation } from 'react-i18next';
import { DateField } from '../../../../components';

const TeamReviewModalPresenter = ({
  isModalOpen,
  closeModal,
  trans,
  answerSubmit,
  evaluationSubmit,
}: TeamReviewQuestionnaireModelProps) => {
  const employeesData = useAppSelector(
    (state: any) => state.PerformanceSlice?.employeeData,
  );
  const evaluatorSheetData = useAppSelector(
    (state: any) => state.evaluatorDetails?.evaluatorSheetData,
  );
  const evaluatorLoader = useAppSelector(
    (state: any) => state.evaluatorDetails?.evaluatorLoader,
  );
  const evaluatorId = useAppSelector(
    (state: any) => state.evaluatorDetails?.evaluatorId,
  );
  const evaluatorData = useAppSelector(
    (state: any) => state.evaluatorDetails?.evaluatorData,
  );
  const evaluatorSheetID = useAppSelector(
    (state) => state.evaluatorDetails?.evaluatorSheetId,
  );
  const answerId = useAppSelector(
    (state: any) => state.evaluatorDetails?.answerId,
  );
  const tempEvaluatorSheetData = useAppSelector(
    (state: any) => state.evaluatorDetails?.tempEvaluatorSheetData,
  );
  const [isSignOff, setIsSignOff] = useState(false);
  const [evaluatorEmpId, setEvaluatorEmpId] = useState([]);
  const { get_emp_details } = employeesData || {};
  const { employee, cycle, answers, questionnaire } = evaluatorSheetData || {};
  const { title, subtitle } = tempEvaluatorSheetData || {};
  const [questionAnswers, setQuestionAnswers] = useState<{
    [key: string]: Answer;
  }>();
  const [score, setScore] = useState<{ [key: string]: Score }>();

  const dispatch = useAppDispatch();
  const checkboxData = [
    { id: 1, label: trans('sign-off'), defaultChecked: 'false' },
  ];
  const { t, i18n } = useTranslation();

  const radioButton = {
    backgroundColor: '#FAFAFA',
    borderRadius: '0.3em',
    padding:
      i18n.language === 'en' ? '0.3em 6em 0.3em 0.3em' : '0.3em 0em 0.3em 6em',
    marginBottom: '0.5em',
    color: '#575757',
  };

  const handelShortAnswer = (question: Question, event: any) => {
    const answer: Answer = {
      answerOptionId: question.answerOptions[0]?.id,
      questionId: question.id,
      value: event.target.value,
    };

    setQuestionAnswers({ ...questionAnswers, [question.id]: answer });
  };

  const handelScore = (question: Question, e: any) => {
    setScore({
      ...score,
      [question.id]: { score: e.target.value },
    });
  };
  const handelOptionAnswer = (question: Question, answerOption: any) => {
    const answer: Answer = {
      answerOptionId: answerOption.id,
      questionId: question.id,
      value: answerOption.id,
    };

    setQuestionAnswers({ ...questionAnswers, [question.id]: answer });
  };

  const getStoredAnswerByQuestionId = (questionId: string) => {
    return answers?.find((answer: any) => answer.questionId == questionId);
  };

  const handleAnswerSave = () => {
    const data = {
      evaluation_sheet_id: evaluatorSheetID,
      answers: questionnaire.questions
        .filter(
          (question: Question) =>
            questionAnswers?.[question.id] ||
            getStoredAnswerByQuestionId(question.id),
        )
        .map((item: Question) => {
          const currentAnswer: Answer = getStoredAnswerByQuestionId(item.id);
          const isShortAnswer: boolean = item.type === SHORT_ANSWER;
          const requestAnswer = questionAnswers?.[item.id];
          const currentScore = score?.[item.id]?.score;
          return {
            ...mapAnswer(
              currentAnswer,
              isShortAnswer,
              requestAnswer,
              item,
              currentScore,
            ),
          };
        }),
    };
    answerSubmit(data);
    handleClose();
  };

  const handleEvaluatorSubmit = () => {
    const data = {
      evaluation_sheet_id: evaluatorSheetID,
      answers: questionnaire.questions.map((question: Question) => {
        const currentAnswer: Answer = getStoredAnswerByQuestionId(question.id);
        const isShortAnswer: boolean = question.type === SHORT_ANSWER;
        const requestAnswer = questionAnswers?.[question.id];
        const currentScore = score?.[question.id]?.score;
        return {
          ...mapAnswer(
            currentAnswer,
            isShortAnswer,
            requestAnswer,
            question,
            currentScore,
          ),
        };
      }),
    };
    questionnaireSubmit(
      data,
      questionnaire.questions,
      answers,
      questionAnswers,
      evaluationSubmit,
    );
    handleClose();
  };

  const handleClose = () => {
    dispatch(setEvaluatorData([]));
    dispatch(setEvaluatorSheetData([]));
    dispatch(setEvaluatorSheetId(''));
    dispatch(setEvaluationId(''));
    dispatch(setEvaluatorId(''));
    dispatch(setApiTrigger(''));
    dispatch(setQuestionnaireId(''));
    dispatch(setAnswerId(''));
    dispatch(setEvaluatorUserId(0));
    dispatch(setKpiId(''));
    dispatch(setTempEvaluatorSheetData([]));
    dispatch(setTriggerData(false))
    closeModal();
  };
  return (
    <CustomModal
      isModalOpen={isModalOpen}
      modalHeight="95%"
      modalWidth="80vw"
      overflowY={'auto'}
    >
      <CompDirection>
        <Grid spacing={2} container>
          <Grid item xs={12}>
            <Box
              style={{
                maxWidth: '30%',
                width: 'auto',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Box style={{ cursor: 'pointer' }} onClick={() => handleClose()}>
                <i className="las la-arrow-left" style={{ color: '#7C0E6F' }} />
              </Box>
              <Box style={{ marginLeft: '0.5em' }}>
                <Avatar src={employee?.profileImage} />
              </Box>
              <Box style={{ marginLeft: '0.5em' }}>
                <Typography
                  style={{
                    color: '#000000',
                    fontSize: '0.75em',
                    fontWeight: 'bold',
                    fontFamily: fonts.fontFamily,
                  }}
                >
                  {employee?.name}
                </Typography>
                <Typography
                  style={{
                    color: '#00000080',
                    fontSize: '0.7em',
                    fontFamily: fonts.fontFamily,
                  }}
                >
                  {employee?.designationName}
                </Typography>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} md={4} lg={3}>
            <Box
              style={{
                border: '1px solid #0000001F',
                padding: '1em',
                borderRadius: '7px',
              }}
            >
              <DetailBox
                title={trans('Start Date')}
                subtitle={
                  <DateField
                    value={cycle?.startDate}
                    format={baseDateFormatting}
                  />
                }
              />
              <DetailBox
                title={trans('End Date')}
                subtitle={
                  <DateField
                    value={cycle?.endDate}
                    format={baseDateFormatting}
                  />
                }
              />
              <DetailBox
                title={trans('Department')}
                subtitle={employee?.departmentName}
              />
              <DetailBox title={trans('emp-id')} subtitle={employee?.id} />
              <DetailBox
                title={trans('Hire Date')}
                subtitle={moment(
                  get_emp_details?.emp_job_detail?.hire_date,
                ).format(baseDateFormatting)}
              />
            </Box>
            {evaluatorLoader ? (
              <Stack spacing={1}>
                <Box style={styles.evaluatorButton}>
                  <Skeleton variant="circular" width={40} height={40} />
                  <Skeleton />
                </Box>
              </Stack>
            ) : (
              evaluatorData.length > 0 &&
              evaluatorData?.map((data: any, index: number) => {
                return (
                  <Box
                    key={index}
                    onClick={() => {
                      dispatch(setTriggerData(true))
                      dispatch(setEvaluatorId(data?.evaluatorId));
                      dispatch(setEvaluatorUserId(data?.userId));
                    }}
                    style={{
                      ...styles.evaluatorButton,
                      backgroundColor:
                        data?.evaluatorId === evaluatorId ? '#F5ECF4' : 'white',
                    }}
                  >
                    <Box style={{ display: 'flex', alignItems: 'center' }}>
                      <Avatar src={data?.profile_image} />
                      <Box style={{ marginLeft: '1em' }}>
                        <Typography
                          style={{
                            color: '#000000',
                            fontSize: '0.75em',
                            fontWeight: 'bold',
                          }}
                        >
                          {`${data?.firsName} ${data?.lastName}`}
                        </Typography>
                        <Typography
                          style={{
                            color: '#00000080',
                            fontSize: '0.7em',
                            fontFamily: fonts.fontFamily,
                          }}
                        >
                          {data?.roleName}
                        </Typography>
                      </Box>
                    </Box>
                    <Button
                      style={
                        data?.status === PENDING
                          ? styles.pendingBox
                          : styles.completedBox
                      }
                    >
                      {data?.status}
                    </Button>
                  </Box>
                );
              })
            )}
          </Grid>
          <Grid item xs={12} md={6} lg={9}>
            <Box
              style={{
                border: '1px solid #0000001F',
                padding: '1em',
                borderRadius: '7px',
                height: 'auto',
              }}
            >
              <Typography
                style={{
                  color: '#000000',
                  fontSize: '1.50em',
                  fontWeight: 'bold',
                  fontFamily: fonts.fontFamily,
                }}
              >
                {title}
              </Typography>
              <Typography
                style={{
                  color: '#616161',
                  fontSize: '0.80em',
                  fontWeight: 'bold',
                  fontFamily: fonts.fontFamily,
                }}
              >
                Self Assesment
                {subtitle}
              </Typography>
              <Box>
                <Typography
                  style={{
                    color: '#000000',
                    fontSize: '1.35em',
                    fontWeight: 'bold',
                    fontFamily: fonts.fontFamily,
                    marginTop: '0.5em',
                  }}
                >
                  {questionnaire?.title}
                </Typography>
                <Typography
                  style={{
                    color: '#000000',
                    fontSize: '0.80em',
                    marginTop: '0.5em',
                    fontFamily: fonts.fontFamily,
                  }}
                >
                  <span style={{ color: '#000000', fontWeight: 'bold' }}>
                    Note:
                  </span>{' '}
                  {questionnaire?.description}
                </Typography>
                {questionnaire?.questions?.map(
                  (value: any, QuestionIndex: number) => {
                    return (
                      <Box key={QuestionIndex}>
                        <Typography
                          style={{
                            color: '#000000',
                            fontSize: '1.20em',
                            fontWeight: 'bold',
                            fontFamily: fonts.fontFamily,
                            marginTop: '2em',
                          }}
                        >
                          {value?.title}
                        </Typography>
                        <Typography
                          style={{
                            color: '#00000080',
                            fontSize: '1em',
                            fontWeight: 'bold',
                            fontFamily: fonts.fontFamily,
                            marginTop: '0.5em',
                          }}
                        >
                          {value?.subtitle}
                          <h2 style={{ fontSize: "0.85em" }}>
                            {value?.description}
                          </h2>
                        </Typography>

                        <Box>
                          {value.type === SHORT_ANSWER ? (
                            <>
                              <Box marginTop={'1em'} />
                              <CustomTextField
                                multiline={true}
                                label={trans('answer')}
                                rows={5}
                                type="string"
                                value={
                                  questionAnswers?.[value?.id]?.value ??
                                  getStoredAnswerByQuestionId(value?.id)?.value
                                }
                                onChange={(
                                  e: React.ChangeEvent<HTMLInputElement>,
                                ) => {
                                  handelShortAnswer(value, e);
                                }}
                              />
                              <Box marginTop={'2em'} />
                              <CustomTextField
                                multiline={false}
                                label={trans('score')}
                                type="number"
                                value={
                                  score?.[value.id]?.score ??
                                  getStoredAnswerByQuestionId(value?.id)?.score
                                }
                                onChange={(
                                  e: React.ChangeEvent<HTMLInputElement>,
                                ) => {
                                  handelScore(value, e);
                                }}
                              />
                            </>
                          ) : (
                            <>
                              <Box sx={{ marginTop: '1em' }}>
                                <CustomRadioButton
                                  options={value?.answerOptions}
                                  style={radioButton}
                                  fontSize="0.75em"
                                  existOption={
                                    getStoredAnswerByQuestionId(value.id)
                                      ?.answerOptionId
                                  }
                                  setValue={(answerOption: any) => {
                                    handelOptionAnswer(value, answerOption);
                                  }}
                                />
                              </Box>
                            </>
                          )}
                        </Box>
                      </Box>
                    );
                  },
                )}
              </Box>

              <Box marginTop={'2em'} />
              <CustomTextField
                multiline={true}
                label={trans('signature')}
                rows={0.2}
                type="string"
              />
              <CustomCheckbox
                style={{
                  color: '#92929D',
                  fontFamily: 'lato',
                  marginBottom: '1em',
                  marginTop: '1em',
                }}
                options={checkboxData}
                onChange={(e: any) => {
                  setIsSignOff(e.target.checked);
                }}
                checked={isSignOff}
              />
            </Box>
          </Grid>
        </Grid>
      </CompDirection>
      <Box style={{ marginTop: '35px' }} />
      <ModalFooter
        submitButtonDisable={isSignOff ? false : true}
        isSaveButton
        onClickSave={() => handleAnswerSave()}
        onClickCancel={() => handleClose()}
        onClickSubmit={() => handleEvaluatorSubmit()}
      />
    </CustomModal>
  );
};

export default TeamReviewModalPresenter;
